import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircleBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12.5279,
			r: 12,
			fill: "#2C70EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 5.76463L12 13.7164",
			stroke: "white",
			strokeWidth: 2.23271
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15.9697L12 17.8826",
			stroke: "white",
			strokeWidth: 2.23271
		})
	]
});
export default SvgInfoCircleBlack;
